<template>
  <div class="body">
    <div style="width: 100%; background: white;">
			<div class="container platform business-loan">
				<div class="row business-loan-box american-credit-partner">
					<div class="col-12 col-lg-5 offset-lg-1">
						<div class="business-loan-box-left-inner">
							<!-- <h1>American Credit<sup>®</sup><br>career opportunities</h1> -->
              <h1>American Credit® career opportunities</h1>
							<!-- <button @click="this.window.location.href='/get-start'" style="background-color: rgb(84, 86, 255); color: #ffffff; font-size: 16px; font-weight: 700; height: 53px; width: 169px; border-radius: 26.5px; border: none;">Apply Now</button> -->
							<p style="font-size: 18px; line-height: 30px; margin-top: 30px;"><span style="color: #696969; font-weight: 400;">Looking for rewarding and challenging career opportunities at the America’s fast growing fintech company in Silicon Valley? </span><span style="color: #5456ff; font-weight: 700; white-space: nowrap;"><a href="mailto:jobs@amcredit.com">Get Started <i class="fa fa-long-arrow-right"></i></a></span></p>
							<br />
						</div>
					</div>
					<div class="col-12 col-lg-5 business-loan-box-right">
						<img class="american-credit-career-head-img" src="../assets/imgs/American_Credit_Career_Opportunities.png" alt="American Credit Career Opportunities"/>
					</div>
				</div>
			</div>
		</div>

    <div style="width: 100%; background: #053a7a;">
      <div class="container bluebg text-center">
        <br />
        <h2 class="display-5 text-whitee text-center font-weight-bolder">Career opportunities at American Credit</h2>

        <div class="contexbox1 text-center">
          <br />
          <p class="text-white h5-style">
            American Credit® is a technology-driven financing company that uses innovative online tools and technology to change the way businesses secure financing, and we are looking for talented, motivated individuals to join our team. We reward and encourage independent thinkers who thrive in a fast-paced environment that is void of bureaucracy and micromanagement. If you embrace technology and have a desire to work in a dynamic atmosphere with a diverse group of highly talented individuals, make American Credit the launching pad for your successful career.
            <br />
            <br />American Credit is an equal opportunity employer.
          </p>
          <!-- <h6 class="text-whitee">American Credit sponsors H1-B visa.</h6> -->

          <p class="h5-style">
            Please email your resume to:
            <a href="mailto:jobs@AmCredit.com" class="link-white">
              <span style="text-decoration: underline;">jobs@AmCredit.com</span>
            </a>
          </p>
          <br />
        </div>
      </div>
    </div>

    <div style="width: 100%; background: #f6f9ff;">
			<div class="container" style="background: #f6f9ff;">
        <!-- <div class="contexbox1 text-center"> -->
          <div width="100%" class="job-list bg-light">
            <div class="job-item">
              <h3>Invoice/AR Financing Sales/Business Development Officer</h3>
              <p>Senior Level</p>
              <p>Palo Alto, CA<button v-on:click="toggle9 = !toggle9" :class="{'is-active': toggle9}">
                <span v-if="!toggle9">View Detail</span>
                <span v-else>Hide Detail</span>
              </button></p>
            </div>
            <div class="job-item-detail" v-show="toggle9">
              <p>American Credit (https://amcredit.com) is looking for an experienced sales/Business Development Officer (BDO) for the generation and development of new business opportunities in the field of invoice/AR financing. The successful candidate will be a consummate and credible sales professional selling comprehensive accounts receivable financing services to the owners of small to medium sized business-to-business companies with sales of $500K to $50MM per year. The role is focused purely on new business and is suited to people who are well-connected, sales hungry and those who can utilize their exceptional sales skills with effective and successful results.</P>
              <p>Responsible To: National Marketing and Sales Director</P>
              <p>External relationships: Bank Lending Officers, Owners and CFO’s of small business-to business companies with annual sales of $500K to $50MM a year, and Factoring Brokers</P>
              <p>Internal relationships: Company President, National Marketing and Sales Director, Underwriting Team and Account Executives</P>
              <p>Compensation: Experience level with determine package offered</P>
              <p><strong>Main Job Responsibilities:</strong></P>
              <ul>
                <li>Extensive experience and operating knowledge of invoice/accounts receivable financing.</li>
                <li>A pro at presenting American Credit to potential clients through direct communication in face to face meetings, telephone calls, and emails.</li>
                <li>Self-lead generation and appointment setting are required.</li>
                <li>Provide weekly comprehensive sales activity reports to the National Marketing and Sales Director.</li>
                <li>To actively and successfully manage the sales process: lead generation; credentials pitch; asking questions; solution pitch; negotiation; close; handover to the account management team.</li>
                <li>To possess drive, motivation and acute attention to detail in ensuring all sales opportunities to American Credit are captured and explored.</li>
                <li>To have individual responsibility for new business and will be expected to self-manage. However, you will be part of a growing team of people with the same job title. Support is available by the National Marketing Director and Company President for complex large pitches and strategies.</li>
                <li>Represent American Credit at industry events and tradeshows with a professional manner and polished appearance with the intention of gaining new business leads and contacts.</li>
                <li>Create and be accountable for all client proposals, agreements and any further documentation, following American Credit procedure.</li>
                <li>A thorough understanding of clients’ financial objectives including their Return on Investment (ROI) objectives.</li>
                <li>To effectively interact with other departments including the marketing department, underwriting and account management teams when handing over deals ensuring you fully and correctly brief all team members in every aspects of the sale.</li>
                <li>To keep updated regarding the state of the factoring industry and collect updates on the activities of the competition.</li>
                <li>Ensuring American Credit remains proactive and responsive to prospective clients.</li>
              </ul>
              <p>An American Credit Team Member is... Part of what makes American Credit as successful as it is are the highly motivated people who work here and their enthusiasm for Factoring. We recruit individuals whose honesty, integrity, initiative and creative approach to problem solving shines through. An inspiration to your colleagues, you are well-connected, tenacious, driven and highly motivated sales professional with a proven record of success in the B2B selling environment with the experience of selling to successful companies at the ownership level. Hungry for success and with a committed motivation to getting things done, you always place the client at the center of everything you do.</p>
              <p><strong>Skills, Knowledge and Experience required:</strong></P>
              <ul>
                <li>Proven success in your sales ability and demonstrable full knowledge of the sales process.</li>
                <li>Confident negotiator and ability to ‘close the deal’.</li>
                <li>Strong client management skills and ability to keep promises.</li>
                <li>Capable of hands on problem-solving, with ability to generate ideas and solutions.</li>
                <li>A positive and determined approach to researching and analyzing new business opportunities.</li>
                <li>Ability to use own initiative and pay close attention to detail.</li>
                <li>Ability to cope with competing demands and to prioritize tasks.</li>
                <li>Strong communication skills in all forms including written, oral, email, telephone, and presentation.</li>
                <li>Excellent organizational and time management skills.</li>
                <li>A positive working attitude toward all people.</li>
                <li>Capable of working independently.</li>
              </ul>
              <p>Education: A 4-Year degree is required.</p>
            </div>

            <div class="job-item">
              <h3>Director of Business Development</h3>
              <p>Senior Level</p>
              <p>Palo Alto, CA<button v-on:click="toggle4 = !toggle4" :class="{'is-active': toggle4}">
                <span v-if="!toggle4">View Detail</span>
                <span v-else>Hide Detail</span>
              </button></p>
            </div>
            <div class="job-item-detail" v-show="toggle4">
              <p>American Credit, a fintech secured business loan lender based in Palo Alto, CA, is looking for a director of business development. In this role, you will develop and implement strategies to grow our strategic partner base, as well as drive growth through our channel partners. You will sell our secured loan products, primarily equipment financing and invoice/AR financing in a distributed sales model that has massive scaling potential. You own the relationship with the CEO and key decision makes across your book of partnerships.</P>
              <p><strong>Responsibilities:</strong></P>
              <ul>
                <li>Own a pipeline of channel partners and manage the daily deal flow to drive revenue to American Credit.</li>
                <li>Educate your partners on our financing products, partnership program, and customer on-boarding process</li>
                <li>Collaborate with internal sales team, risk, and operations to help your channels close more deals</li>
                <li>Provide continuous training and build lasting relationships to grow your existing book of business over time</li>
              </ul>
              <p><strong>Qualifications:</strong></P>
              <ul>
                <li>2+ years of inbound telephone/sales experience. Financial/capital experience is a plus.</li>
                <li>Bachelor's degree.</li>
                <li>Great writing/oral communication skills; comfortable talking with C-level officers.</li>
                <li>Leadership potential & interest, A demonstrated passion for selling, Willingness to learn</li>
                <li>Ready to work for a fast-growing start-up, Quick and detail oriented, Promptness and always on time</li>
              </ul>
            </div>

            <div class="job-item">
              <h3>Medical/Construction Equipment Financing Sales</h3>
              <p>Senior Level</p>
              <p>Palo Alto, CA<button v-on:click="toggle3 = !toggle3" :class="{'is-active': toggle3}">
                <span v-if="!toggle3">View Detail</span>
                <span v-else>Hide Detail</span>
              </button></p>
            </div>
            <div class="job-item-detail" v-show="toggle3">
              <p>Accumulated many years of experiences and clientele in equipment financing? Looking for opportunities to leverage your experience and connections to fintech business loan space? American Credit (www.amcredit.com) is looking for regional managers to join our equipment vendor services team. Our ideal candidates have at least 2 years of experience working with equipment vendors/dealers, and are comfortable working both individually and on a team. These sales manager jobs can be either onsite or remote. Even though the job requires face-to-face sales calls with equipment vendors/dealers, you could work from the comfort of your own home most of the time.</P>
              <p><strong>Industries We Are Hiring For:</strong></P>
              <ul>
                <li>Franchise</li>
                <li>Dentist Office</li>
                <li>Automotive</li>
                <li>Commercial Vehicle</li>
                <li>Construction Equipment</li>
                <li>Healthcare</li>
                <li>Office Imaging</li>
                <li>Point-of-Use Water</li>
                <li>Land Surveying</li>
                <li>Securities</li>
                <li>Technology</li>
                <li>Fitness</li>
                <li>Restaurant</li>
                <li>Software</li>
                <li>Video/AV</li>
              </ul>
              <p><strong>Responsibilities:</strong></P>
              <ul>
                <li>Actively prospect and cultivate new vendor and lessee relationships</li>
                <li>Drive volume and further develop existing vendor relationships</li>
                <li>Maintain an average of 400 outbound vendor-focused calls per week</li>
                <li>Assist vendor salespeople with leasing sales training in the form of sales meetings, conference calls, trade shows, and one-on-one phone calls</li>
                <li>Attend various trade shows nationwide as needed</li>
              </ul>
              <p><strong>Qualifications:</strong></P>
              <ul>
                <li>2 years of experience in the equipment financing industry</li>
                <li>Strong interpersonal skills with a focus on relationship building</li>
                <li>Effective leadership skills with ability to motivate others</li>
              </ul>
              <p>The above statements are intended to describe the general nature and level of work being performed by people assigned to this classification. They are not to be construed as an exhaustive list of all responsibilities, duties, and skills required of personnel so classified. All personnel may be required to perform duties outside of their normal responsibilities from time to time, as needed.</p>
            </div>

            <div class="job-item">
              <h3>Chief Investment Officer</h3>
              <p>Senior Level</p>
              <p>Palo Alto, CA<button v-on:click="toggle5 = !toggle5" :class="{'is-active': toggle5}">
                <span v-if="!toggle5">View Detail</span>
                <span v-else>Hide Detail</span>
              </button></p>
            </div>
            <div class="job-item-detail" v-show="toggle5">
              <p><strong>Fund Raising Officer</strong></P>
              <p>Accumulated many years of experiences and financial institution clientele in fund-raising and investor relationship management? Looking for opportunities to leverage your experience and connections to fintech business loan space? American Credit® (https://amcredit.com) is dedicated to secured business lending and focuses only on equipment financing and invoice financing. We are looking for a fund-raising specialist to lead our Seed II fund raising effort. Our ideal candidates have at least 5 years of experience working with start-up fund raising and is familiar with fintech business lending section. The candidate is required to have experience both in equity as well as debt financing and have an established track record.</P>
              <p><strong>The Fund Raising/Investor Relations specialist will lead all aspects of American Credit® equity and debt financing fundraising, investor relations management, with key responsibilities including but not limited to:</strong></P>
              <ul>
                <li>Lead in the creation of a capital raising strategy to all suitable institutional investors.</li>
                <li>Lead systematic fundraising campaigns to reach all suitable investors</li>
                <li>Preparation of and ongoing update all presentation materials to investors</li>
                <li>Manage investor inquires, requests and other follow-up, ensuring timely responses</li>
                <li>Network with other professionals to introduce the firm’s products both in person, by phone, or through social media</li>
                <li>Maintenance and organization of internal CRM system including logging of all investor calls, meetings and relevant investor updates and ensuring that all updates and follow-ups are properly tracked</li>
                <li>Strategize and prepare materials for investor meetings</li>
                <li>Complete investor due diligence requests and handle other investor queries</li>
                <li>Manage investor closing process during fundraising</li>
                <li>Assist in planning and execution of annual investor conference</li>
                <li>Assist with strategic firm initiatives, research projects, and other miscellaneous projects</li>
                <li>Draft presentations and memorandums for senior management</li>
              </ul>
              <p><strong>Ideal candidate:</strong></p>
              <ul>
                <li>Executive Leadership experience in a fintech company that went through fund-raising to explosive growth</li>
                <li>Background raising funds to support a high growth model</li>
                <li>Strong Financial Leadership, growing teams, developing processes, managing internal and external relationships</li>
                <li>Passionate, Entrepreneurial-spirited leader</li>
              </ul>
              <p><strong>Knowledge:</strong></p>
              <ul>
                <li>Financial markets</li>
                <li>Securities industry and products</li>
                <li>Firm and its affiliates working structure, practices, philosophy, and strategies</li>
                <li>Broker/Dealer and FINRA policies and guidelines</li>
              </ul>
              <p><strong>Skills:</strong></p>
              <ul>
                <li>Conducting concise effective professional presentations to small and large audiences</li>
                <li>Understanding and able to explain advanced concepts, financial models, formulas and innovative business plans across multiple industries</li>
                <li>Determining clients’ wealth objectives and available assets through efficient questioning and focused listening</li>
                <li>Manage multiple comprehensive tasks in a fast-paced work environment</li>
                <li>Detailed to maintain quality standards while increasing workflow efficiencies</li>
                <li>Organized follow-up to achieve closed sales</li>
              </ul>
              <p><strong>Attributes:</strong></p>
              <ul>
                <li>Appropriate relational styles and able to communicate effectively and professionally, oral and written, internal and external, with expertise in the securities markets, to accomplish objectives</li>
                <li>Successfully determine and address concerns and clearly answer complex questions</li>
                <li>Consistently present the firm in a professional and sophisticated manner</li>
                <li>Effectively market yourself and the firm’s investment products with unlimited persistence starting with and through the prospecting process until successful closings</li>
                <li>Able to work independently</li>
                <li>Self-starter, self-motivated, self-managing</li>
                <li>Confident and comfortable in a sales environment</li>
              </ul>
              <p><strong>Educational/Previous Experience Requirements:</strong></p>
              <ul>
                <li>College Degree and/or two or more years financial industry fund raising experience</li>
              </ul>
              <p><strong>Licenses/Certifications:</strong></p>
              <ul>
                <li>Series 7 and 63 Licenses, or 82 and 63, already in place or obtained within 30 days.</li>
              </ul>
              <p><strong>Additional Notes:</strong></p>
              <p>This position requires a background check. If you are licensed and if you have a prior bankruptcy, U-4 disclosures, credit issues, criminal convictions, civil judgments, pending litigation, termination from a previous employer, or any other matter subject to FINRA disclosure regulations, you must disclose these items during the pre-screening process. You will be required to sign a confidentiality agreement as a part of our interview process.</p>
              <!-- <p><strong></strong></p>
              <ul>
                <li></li>
                <li></li>
              </ul> -->
            </div>

            <div class="job-item">
              <h3>Director of Operations</h3>
              <p>Mid to Senior Level</p>
              <p>Palo Alto, CA<button v-on:click="toggle8 = !toggle8" :class="{'is-active': toggle8}">
                <span v-if="!toggle8">View Detail</span>
                <span v-else>Hide Detail</span>
              </button></p>
            </div>
            <div class="job-item-detail" v-show="toggle8">
              <p>The ideal candidate is a highly analytical leader who will join our senior management team. You will be responsible for leading the company's day-to-day business operations (managing the company budget, ensuring operational compliance is followed, and addressing administrative issues).</P>
              <p><strong>Responsibilities:</strong></P>
              <ul>
                <li>Measure the effectiveness of all processes (budget, operations, and management, etc.)</li>
                <li>Determine company's strategic growth as part of the executive team</li>
                <li>Coordinate cross-functional initiatives and projects</li>
              </ul>
              <p><strong>Qualifications:</strong></P>
              <ul>
                <li>Bachelor's degree in Business Management or related discipline 5 -10 years of relevant experience</li>
                <li>Strong interpersonal and communication skills</li>
                <li>Experience in banking and fixed income product management</li>
                <li>Experience in lending and loan underwriting</li>
                <li>Experience in loan funding source channels and private placement arrangement</li>
                <li>Experience in sales and marketing management</li>
              </ul>
            </div>

            <div class="job-item">
              <h3>Collateral Manager</h3>
              <p>Mid Level</p>
              <p>Palo Alto, CA<button v-on:click="toggle2 = !toggle2" :class="{'is-active': toggle2}">
                <span v-if="!toggle2">View Detail</span>
                <span v-else>Hide Detail</span>
              </button></p>
            </div>
            <div class="job-item-detail" v-show="toggle2">
              <p>We provide unparalleled earning and growth potential to qualified candidates with potential and a proven record in this field. This is an exciting opportunity to join a highly analytical, data-centric team at a fast-growing company. The Collateral Manager provides operational support and risk monitoring to the Asset Based Lending group by reviewing and analyzing client-supplied reports, field examinations, and loan documentation. This position will interact with clients on a daily basis and will have an assigned portfolio of accounts.</P>
              <p><strong>Responsibilities:</strong></P>
              <ul>
                <li>Work with the Portfolio and Technology team to develop detailed, automated proprietary collateral reporting, monitoring, and forecasting tools.</li>
                <li>Review/analyze Borrowing Base Certificate (BBC) and supporting documentation for accuracy and completeness; update collateral related information in collateral monitoring system; reconcile collateral, loans, and unapplied and in-transit cash, as well as excess availability between the collateral monitoring system and BBC; identify and resolve outstanding items.</li>
                <li>Analyze accounts receivable and inventory reports, on a daily, weekly and monthly basis and calculate ineligible collateral; review and incorporate relevant audit and exam findings; prepare monthly reconciliation of accounts receivable collateral shown in the monitoring system to borrower accounts receivable aging reports and final borrowing base certificates for month.</li>
                <li>Ensure compliance with all regulations, policies, and procedures. Work on Specialty Finance projects as assigned.</li>
                <li>Ensure compliance with all regulations, policies, and procedures.</li>
              </ul>
              <p><strong>Qualifications:</strong></P>
              <ul>
                <li>Bachelor's degree in Economics, Finance or Business preferred</li>
                <li>3+ years experience in collateral management. ABLsoft or ABLM.NET experience is a plus.</li>
                <li>Extensive previous experience with and a thorough understanding of cash & collateral management process along with counterparty risk management</li>
                <li>Ability to work both independently and collaboratively in a demanding, fast-paced and fluid environment, while maintaining superior attention to detail.</li>
              </ul>
            </div>

            <!-- <div class="job-item">
              <h3>Sales Development Manager</h3>
              <p>Entry to Mid Level</p>
              <p>Palo Alto, CA<button v-on:click="toggle3 = !toggle3" :class="{'is-active': toggle3}">
                <span v-if="!toggle3">View Detail</span>
                <span v-else>Hide Detail</span>
              </button></p>
            </div>
            <div class="job-item-detail" v-show="toggle3">
              <p>In this role, you will help make business owners aware of the financing options available to them so they can take their business to a new level. You will have the opportunity to educate and influence them by developing outreach skills that will allow you to target the right customer.</P>
              <p><strong>Responsibilities:</strong></P>
              <ul>
                <li>Reach and connect with small and medium-sized business owners with capital needs. Assist prospects throughout the sales cycle, starting with the completion of a financing application and ending when a prospect makes their initial funding</li>
                <li>Manage a pipeline of 30-50 prospects in various stages of the sales cycle on an ongoing basis. Make 100+ calls per day to warm leads inquiring about our financial products</li>
                <li>Consistently achieve monthly quota targets by effectively selling and up-selling our loan/LOC products</li>
                <li>Provide an excellent client experience for the first 30 days of account ownership</li>
                <li>Qualify potential clients to ensure the right financing product is presented</li>
                <li>Work with the underwriting team to ensure proper documentation and key financial information is collected from the prospect.</li>
              </ul>
              <p><strong>Qualifications:</strong></P>
              <ul>
                <li>2+ years of inbound telephone sales experience. Financial/capital experience is a plus.</li>
                <li>Bachelor's degree.</li>
                <li>A demonstrated passion for selling, Willingness to learn,</li>
                <li>Ready to work for a fast-growing start-up, Quick and detail oriented, Always on time</li>
              </ul>
            </div> -->

            <!-- <div class="job-item">
              <h3>Manager of Investor Relationship</h3>
              <p>Mid Level</p>
              <p>Palo Alto, CA<button v-on:click="toggle5 = !toggle5" :class="{'is-active': toggle5}">
                <span v-if="!toggle5">View Detail</span>
                <span v-else>Hide Detail</span>
              </button></p>
            </div>
            <div class="job-item-detail" v-show="toggle5">
              <p>In this role, you will support institutional and individual investor operating activities. You will have the opportunity to educate and influence by developing outreach skills that will allow you to target the right customer.</P>
              <p><strong>Responsibilities:</strong></P>
              <ul>
                <li>Reach out to accredited and institutional investors to raise more fund for the growing need of the our quality clients.</li>
                <li>Interface directly with on daily basis, providing timely responses and support to their inquiries, and execute and streamline day-to-day operating activities.</li>
                <li>Identify deficiencies and risks in operations</li>
                <li>Be responsible for scoping and troubleshooting ad-hoc operational issues as they occur</li>
                <li>Assist in managing investor due diligences and audit requests and onsite field work arrangements</li>
                <li>Work closely with Product, Technology and Sales Teams to identify features and contribute to the development of platforms, reports and systems used by investors.</li>
                <li>Gain an in-depth knowledge of internal payments and loan processing systems</li>
              </ul>
              <p><strong>Qualifications:</strong></P>
              <ul>
                <li>2+ years experience of finance, investments, or lending industry.</li>
                <li>Bachelor's degree in accounting, finance, business or related fields.</li>
                <li>Self-starter with strong interpersonal and communication skills</li>
                <li>Ready to work for a fast-growing start-up;</li>
                <li>Quick and detail oriented; Promptness and always on time</li>
              </ul>
            </div> -->
            
            <!-- <div class="job-item">
              <h3>Senior Graphic Designer</h3>
              <p>Mid to Senior Level</p>
              <p>Palo Alto, CA<button v-on:click="toggle7 = !toggle7" :class="{'is-active': toggle7}">
                <span v-if="!toggle7">View Detail</span>
                <span v-else>Hide Detail</span>
              </button></p>
            </div>
            <div class="job-item-detail" v-show="toggle7">
              <p>The ideal candidate will be responsible for conceptualizing creative designs for a wide array of media to fit the needs of internal teams and external clients. You will oversee the design's production to ensure the designs are completed in a timely manner. You will also use your knowledge of design software to accomplish these responsibilities.</P>
              <p><strong>Responsibilities:</strong></P>
              <ul>
                <li>Oversee design and production of all online and offline marketing material</li>
                <li>Conceptualize and execute the creative design strategy behind ad campaigns</li>
                <li>Design and produce a wide array of media</li>
                <li>Develop our company brand to increase brand presence</li>
              </ul>
              <p><strong>Qualifications:</strong></P>
              <ul>
                <li>Bachelor's degree or equivalent experience in Graphic Design</li>
                <li>6+ years of creative design experience</li>
                <li>Experience using design software such as InDesign, Photoshop, and Illustrator</li>
                <li>Strong typography skills</li>
              </ul>
            </div> -->

            <div class="job-item">
              <h3>Marketing Manager - Social Media</h3>
              <p>Entry to Mid Level</p>
              <p>Palo Alto, CA<button v-on:click="toggle6 = !toggle6" :class="{'is-active': toggle6}">
                <span v-if="!toggle6">View Detail</span>
                <span v-else>Hide Detail</span>
              </button></p>
            </div>
            <div class="job-item-detail" v-show="toggle6">
              <p>In this role, you will be responsible for helping us build and grow a best-in-class social media presence across multiple platforms to drive brand awareness and client engagement.</P>
              <p><strong>Responsibilities:</strong></P>
              <ul>
                <li>Campaign Strategy and Execution: Work with team, cross-functional partners, and external agencies to support and execute social media strategies as part of larger consumer-facing campaigns. Includes overarching strategy, planning, social copywriting, and editing.</li>
                <li>Social Paid Media Strategy: Work with internal teams to help develop and monitor paid social strategies that support campaign goals. Must be familiar with social paid product offerings and best practices.</li>
                <li>Social Reporting: Work with internal teams to develop appropriate KPIs, monitor performance, optimize content and distribution in real-time, help analyze social data, and create actionable insights and reports.</li>
                <li>Partner closely with cross-functional internal teams including, Digital Media, Communications, Sales Operation, SEM, SEO, Customer Support, to ensure campaigns meet marketing objectives.</li>
                <li>Social media calendar. Manage a calendar and post to our social media accounts to drive high-quality traffic and engagement.</li>
                <li>Customer Support: Ensure quick and effective customer support to inquiries on social platforms, emails, and apps.</li>
              </ul>
              <p><strong>Qualifications:</strong></P>
              <ul>
                <li>3+ years of Social Media or marketing experience.</li>
                <li>Bachelor's degree. Communication, Design, or Business major preferred.</li>
                <li>Strong interpersonal and communication skills</li>
                <li>Graphic Design skill is preferred.</li>
                <li>Experience in banking, fixed income product, or lending/loan underwriting is a plus.</li>
              </ul>
            </div>

            <!-- <div class="job-item">
              <h3>Software Engineer</h3>
              <p>Senior Level</p>
              <p>Palo Alto, CA<button v-on:click="toggle1 = !toggle1" :class="{'is-active': toggle1}">
                <span v-if="!toggle1">View Detail</span>
                <span v-else>Hide Detail</span>
              </button></p>
            </div>
            <div class="job-item-detail" v-show="toggle1">
              <p>American Credit, Inc. in Santa Clara County, CA seeks for Software Engineer to design and optimize company’s loan origination system, website and mobile applications.<br>Requires Master’s degree or foreign equivalent in Computer Science, Computer Engineering or related field plus 3 years of experience in the job offered or related occupation. Email resume to info1@amcredit.com, or mail resume to American Credit, Inc., 2100 Geng Road, Ste 210, Palo Alto, CA 94303.</P>
              <p><strong>Job Responsibilities:</strong></P>
              <ul>
                <li style="list-style: decimal;">Design, develop and maintain front-end websites and mobile applications for company’s loan origination system;</li>
                <li style="list-style: decimal;">Create and develop internal loan application management tools with React/Vue.js; refine application management system based on underwriting procedure requirements and user requirements;</li>
                <li style="list-style: decimal;">Maintain and upgrade backend RESTful APIs of company’s loan origination system; analyze, design and implement new features to modernize and scale the existing system;</li>
                <li style="list-style: decimal;">Optimize company’s loan origination system for better performance, security and scalability, including setting up API Gateway and Load Balancer with NGINX to enhance securities and stabilities of backend servers; building microservice like risk control system; bringing in AI and Blockchain industry trends to optimize system performance and efficiency;</li>
                <li style="list-style: decimal;">Coordinate internal teams to define project milestones and deliverables;</li>
                <li style="list-style: decimal;">Document software components and testing mechanism with detailed design documents and benchmarking data; and</li>
                <li style="list-style: decimal;">Manage and maintain source codes for company’s websites and mobile apps on GitHub; manage development branches to merge into mainline branches.</li>
              </ul>
              <p><strong>Requirements:</strong></P>
              <p>This position requires a Master’s degree or foreign equivalent in Computer Science, Computer Engineering or related field plus 3 years of experience in the job offered or related occupation.<br><br>Additionally, each of the following skills is required:</p>
              <ul>
                <li style="list-style: decimal;">Three years of full-stack development experience with websites and mobile apps;</li>
                <li style="list-style: decimal;">Three years of project management for all aspects of the software development lifecycle;</li>
                <li style="list-style: decimal;">Three years of experience in JavaScript MVC Frameworks (Angular/React/Vue.js), REST API backend development (Node.js/Spring Boot);</li>
                <li style="list-style: decimal;">Must have solid knowledge and proven proficiency in JavaScript, Java, Python, C, C++; and</li>
                <li style="list-style: decimal;">Experience with website security, server stability, cloud server deployment, database management, system data modeling and data migration.</li>
              </ul>
            </div> -->
          </div>
        <!-- </div> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      toggle1: false,
      toggle2: false,
      toggle3: false,
      toggle4: false,
      toggle5: false,
      toggle6: false,
      toggle7: false,
      toggle8: false,
      toggle9: false
    }  
  },
  computed: {},
  methods: {},
  mounted() {
    var seo = document.getElementById("seo");

    var meta = document.getElementById("seometa");
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      meta.id = "seometa";
      document.head.insertBefore(meta, seo);
    }

    var keywords = document.getElementById("seokeywords");
    if (!keywords) {
      keywords = document.createElement("meta");
      keywords.name = "keywords";
      keywords.id = "seokeywords";
      document.head.insertBefore(keywords, seo);
    }

    document.title = "Careers | American Credit";
    meta.content = "American Credit is looking to hire motivated individuals, who are ready to help empower America's business owners. See our vacancies & contact us anytime!";
    keywords.content = "Job, career, career opportunities, Job Opportunities, Palo Alto, compensation";
  }
};
</script>

<style scoped lang="scss">
  @import "../assets/css/global.scss";
  @import "../assets/css/fonts.css";

  .american-credit-career-head-img {
    // width: 720px !important;
    margin-top: 60px !important;
  }

  .h5-style {
    font-size: 1.25rem;
    line-height: 1.2;
  }

  .job-list {
    text-align: left;
    color: #5b5b5b;
    padding-top: 30px;
    padding-left: 10%;
    padding-right: 10%;
    padding-bottom: 30px;
    .job-item {
      margin-bottom: 10px;
      padding-left: 20px;
      padding-right: 20px;
      padding-bottom: 2px;
      border-left: 10px solid #007bff;
      background-color: #E5E1E6;
      p {
        margin-bottom: .5em;
      }
      button {
        &.is-active {
          background-color: #999999;
          color: orange;
        }
        float: right;
        background-color: #007bff;
        color: white;
        border: 0;
      }
      button:focus {
        outline: none;
      }
    }
    .job-item-detail {
      padding-top: 10px;
      padding-bottom: 20px;
      padding-left: 30px;
      padding-right: 20px;
      ul {
        margin-bottom: 1rem;
        li {
          list-style: disc;
          margin-left: 1.5rem;
        }
      }
    }
  }

@media screen and (max-width: 767px) {

  .business-loan-box-left-inner {
    margin-top: 0 !important;
    padding-top: 20px;
    padding-bottom: 40px;
  }

  .american-credit-career-head-img {
    // width: 100% !important;
    margin-top: 0px !important;
    margin-bottom: 20px !important;
  }
  
  .job-list {
    padding-left: 5px;
    padding-right: 5px;
    padding-top: 10px;
    padding-bottom: 2px;
  }
}
</style>



// WEBPACK FOOTER //
// careers.vue?651ae5fe